import type { ReactNode } from 'react';
import cx from 'clsx';
import styles from './styles.module.css';

interface StepListProps {
  children: ReactNode;
  className?: string;
}

export function StepList({ children, className = '', ...props }: StepListProps): ReactNode {
  return (
    <ul className={cx(styles['step-list'], className)} {...props}>
      {children}
    </ul>
  );
}
